<template>
  <div class="mod-purchase-requisition">
    <el-form :inline="true" :model="dataForm" @keyup.enter.native="pageIndex = 1; getDataList()">
      <el-form-item label="请购单号">
        <el-input v-model="dataForm.requisitionCode" size="small" clearable style="width:150px" />
      </el-form-item>
      <el-form-item label="请购部门">
        <el-input v-model="dataForm.deptName" size="small" clearable style="width:150px" />
      </el-form-item>
      <el-form-item label="申请人">
        <el-input v-model="dataForm.applicantName" size="small" clearable style="width:150px" />
      </el-form-item>
      <el-form-item label="审核">
        <el-select v-model="dataForm.approveStatus" clearable size="small" style="width:100px">
          <el-option label="未审" value="0" />
          <el-option label="已审" value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('purchase:purchaseRequisition:list')" type="primary" size="small" @click="pageIndex = 1; getDataList()">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('purchase:purchaseRequisition:save')" type="primary" size="small" @click="addOrUpdateHandle()">新增</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          v-if="isAuth('purchase:purchaseOrder:save')"
          type="primary"
          size="small"
          :disabled="!selectedRows.length"
          @click="batchConvertHandle"
        >批量转采购</el-button>
      </el-form-item>
    </el-form>

    <el-table
      ref="dataTable"
      :data="dataList"
      border
      v-loading="dataListLoading"
      :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      @selection-change="selectionChangeHandle"
    >
      <el-table-column type="selection" width="45" header-align="center" align="center" :selectable="rowSelectable" />
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="requisitionCode" label="请购单号" min-width="140" header-align="center" align="left">
        <template slot-scope="scope">
          <a v-if="isAuth('purchase:purchaseRequisition:info')" class="code-link" @click="addOrUpdateHandle(scope.row.requisitionId, true)">{{ scope.row.requisitionCode }}</a>
          <span v-else>{{ scope.row.requisitionCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="requisitionDate" label="请购日期" width="110" header-align="center" align="left">
        <template slot-scope="scope">{{ (scope.row.requisitionDate || '').slice(0, 10) }}</template>
      </el-table-column>
      <el-table-column prop="deptName" label="请购部门" min-width="120" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="applicantName" label="申请人" width="100" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="totalQuantity" label="请购数量" width="100" header-align="center" align="left" />
      <el-table-column prop="approveStatus" label="状态" width="90" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag :type="statusTagType(scope.row)" size="small">{{ statusText(scope.row) }}</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      @size-change="val => { pageSize = val; pageIndex = 1; getDataList() }"
      @current-change="val => { pageIndex = val; getDataList() }"
      :current-page="pageIndex"
      :page-sizes="[20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
    />

    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList" @convert-po="convertPoHandle" />
    <convert-po v-if="convertPoVisible" ref="convertPo" @success="getDataList" />
    <batch-convert-po ref="batchConvertPo" @success="onBatchConvertSuccess" />
  </div>
</template>

<script>
import AddOrUpdate from './purchaseRequisition-add-or-update'
import ConvertPo from './purchaseRequisition-convert-po'
import BatchConvertPo from './purchaseRequisition-batch-convert-po'
import request from '../../api/request'
import { fetchPerms } from '../../api/auth'
import { workflowStatusText, workflowStatusTagType } from '../../utils/workflow'

export default {
  name: 'PurchaseRequisition',
  components: { AddOrUpdate, ConvertPo, BatchConvertPo },
  data() {
    return {
      dataForm: { requisitionCode: '', deptName: '', applicantName: '', approveStatus: '' },
      dataList: [],
      selectedRows: [],
      pageIndex: 1,
      pageSize: 20,
      totalPage: 0,
      dataListLoading: false,
      addOrUpdateVisible: false,
      convertPoVisible: false,
      permCodes: []
    }
  },
  created() {
    this.loadPerms()
    this.getDataList()
  },
  activated() {
    this.getDataList()
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      const role = String(user.roleCode || '')
      if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() {
      fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {})
    },
    statusText(row) {
      return workflowStatusText(row.workflowStatus, row.approveStatus)
    },
    statusTagType(row) {
      return workflowStatusTagType(row.workflowStatus, row.approveStatus)
    },
    getDataList() {
      this.dataListLoading = true
      request.post('/purchase/purchaseRequisition/list', {
        currentPage: this.pageIndex,
        pageSize: this.pageSize,
        requisitionCode: this.dataForm.requisitionCode,
        deptName: this.dataForm.deptName,
        applicantName: this.dataForm.applicantName,
        approveStatus: this.dataForm.approveStatus
      }).then(res => {
        const body = res.data || {}
        this.dataList = body.list || []
        this.totalPage = body.totalCount || 0
      }).catch(() => {}).finally(() => { this.dataListLoading = false })
    },
    addOrUpdateHandle(id, readonly) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate && this.$refs.addOrUpdate.init(id, readonly)
      })
    },
    open(id, readonly) {
      this.addOrUpdateHandle(id, !!readonly)
    },
    convertPoHandle(row) {
      if (!row || !row.requisitionId) return
      this.convertPoVisible = true
      this.$nextTick(() => {
        this.$refs.convertPo && this.$refs.convertPo.init(row.requisitionId, row.requisitionCode)
      })
    },
    rowSelectable(row) {
      return String(row.approveStatus) === '2'
    },
    selectionChangeHandle(rows) {
      this.selectedRows = rows || []
    },
    batchConvertHandle() {
      const rows = (this.selectedRows || []).filter(r => String(r.approveStatus) === '2')
      if (!rows.length) {
        this.$message.warning('请至少选择一张已审核的请购单')
        return
      }
      this.$nextTick(() => {
        this.$refs.batchConvertPo && this.$refs.batchConvertPo.init(rows)
      })
    },
    onBatchConvertSuccess() {
      this.selectedRows = []
      if (this.$refs.dataTable) this.$refs.dataTable.clearSelection()
      this.getDataList()
    }
  }
}
</script>

<style scoped>
.code-link { cursor: pointer; color: #348adb; }
</style>
